import { PaylioContext } from "@/context/context";
import { lazy, Suspense, useContext, useMemo } from "react";
import Select from "../select/Select";
import FlowPayDashboardCenter from "./FlowPayDashboardCenter";
import LinkedPaymentSystem from "./LinkedPaymentSystem";
import Recipients from "./Recipients";

const Chart = lazy(() => import("react-apexcharts"));

const month = [
  { id: 1, name: "Jan" },
  { id: 2, name: "Feb" },
  { id: 3, name: "Mar" },
];

const DashboardMain = () => {
  const { activeLefMenu, workspaceTheme } = useContext(PaylioContext);

  const foreColor = workspaceTheme === "dark" ? "#c8ced9" : "#373d3f";

  const options = useMemo(
    () => ({
      labels: [
        "ACH settled",
        "USDC minted",
        "Auto-convert",
        "Pending ACH",
        "Network fees",
      ],
      dataLabels: {
        enabled: false,
      },
      chart: {
        foreColor,
      },
      legend: {
        labels: {
          colors: foreColor,
        },
      },
      stroke: {
        colors: workspaceTheme === "dark" ? ["#161824"] : ["#fff"],
      },
    }),
    [foreColor, workspaceTheme],
  );

  const series = [38, 32, 12, 14, 4];

  return (
    <section
      className={`dashboard-section ${activeLefMenu ? "body-collapse" : ""}`}>
      <div className="overlay pt-120">
        <div className="container-fruid">
          <div className="row">
            <div className="col-xl-8 col-lg-7">
              <div className="section-content">
                <FlowPayDashboardCenter />
              </div>
            </div>
            <div className="col-xl-4 col-lg-5">
              <div className="side-items">
                <div className="single-item">
                  <LinkedPaymentSystem />
                </div>
                <div className="single-item">
                  <div className="section-text d-flex align-items-center justify-content-between">
                    <h6>ACH → crypto mix</h6>
                    <div className="select-box">
                      <Select data={month} btn="bg-transparent border" />
                    </div>
                  </div>

                  <Suspense fallback={null}>
                    <Chart
                      options={options}
                      series={series}
                      type="donut"
                      width="100%"
                      height={380}
                    />
                  </Suspense>
                </div>

                <Recipients />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DashboardMain;
